/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./CollapsibleItem',
	'./ToggleButtonBar',
	'underscore'
], function(CollapsibleItem, ToggleButtonBar, _) {

	var CollapsibleToggleButtonBar = null;

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	CollapsibleToggleButtonBar = ToggleButtonBar.extend([CollapsibleItem], {

		/**
		 * Creates a new item
		 *
		 * @param spec -
		 *            The item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec, root) {
			_.extend(this, spec);
			CollapsibleToggleButtonBar.inherited('init', this, arguments);
			this.rootMenu = root; // CollapsibleItem property
		},

		/**
		 * Toggle handler of button
		 * Synchronizes selected item in buttons and menu items.
		 */
		toggleHandler: function(name) {

			//uncheck current item
			if (this.sCheckedItemName) {
				var oItem = this.itemMap[this.sCheckedItemName];
				if (oItem) {
					oItem.unselect();
				}

				//update tick mark on menu item
				this.updateMenuItemTick(this.collapsedItemMap[this.sCheckedItemName], false);
			}

			//update check item name
			this.sCheckedItemName = name;

			//update tick mark on menu item
			this.updateMenuItemTick(this.collapsedItemMap[this.sCheckedItemName], true);
		},

		/**
		 * Toggle handler of menu item in collapsed mode
		 * Synchronizes selected item in buttons and menu items.
		 */
		updateSelectedItemInHamburgerMenu: function(name) {
			this.toggleHandler(name);

			var oItem = this.itemMap[this.sCheckedItemName];
			oItem.select();
		},

		/**
		 * Draws the items and menu items in rootMenu
		 */
		render: function() {
			//render regular buttons
			this.$el.addClass('hidden-xs');
			CollapsibleToggleButtonBar.inherited('render', this, arguments);

			//render collapsed version
			this.renderCollapsed();

			return this;
		},

		remove: function() {
			_.each(this.collapsedItemMap, (item) => {
				if (item.remove) {
					item.remove();
				}
			});

			CollapsibleToggleButtonBar.inherited('remove', this, arguments);
		}
	});

	return CollapsibleToggleButtonBar;
});
